import { MonthRow, Scenario, ScenarioSummary } from './types.js';
import { equivalentRateApr } from './equivalent-rate.js';
import { roundCents } from './rounding.js';
import { addMonthsToYearMonth } from './timeline.js';

/** Totals of a schedule built for `scenario`; the equivalent rate needs the scenario itself. */
export function summarize(scenario: Scenario, months: MonthRow[]): ScenarioSummary {
  const totalInterest = months.reduce((sum, m) => sum + m.interestPortion, 0);
  const totalPaid = months.reduce((sum, m) => sum + m.interestPortion + m.principalPortion + m.overpayment, 0);
  const maxMonthlyPayment = months.reduce((max, m) => Math.max(max, m.scheduledPayment + m.overpayment), 0);
  const payoffMonth = months.length ? months[months.length - 1].monthIndex : 0;
  const payoffDate = addMonthsToYearMonth(scenario.startDate, payoffMonth);
  const interest = roundCents(totalInterest);

  return {
    scenarioId: scenario.id,
    name: scenario.name,
    totalInterest: interest,
    totalPaid: roundCents(totalPaid),
    actualTermMonths: months.length,
    maxMonthlyPayment: roundCents(maxMonthlyPayment),
    payoffDate,
    equivalentRateApr: equivalentRateApr(scenario, interest),
  };
}
